module.exports = __webpack_public_path__ + "img/nzavo-recipe-detail.2fe73f79.webp";